// SSR stub for zustand — returns no-op store
export function create(initializer: any) {
  const state =
    typeof initializer === 'function'
      ? initializer(
          () => state,
          () => state,
          {},
        )
      : initializer
  const store = () => state
  store.getState = () => state
  store.setState = () => {}
  store.subscribe = () => () => {}
  store.destroy = () => {}
  return store
}

export default create
